/**
 * 工具类
 */
import Cookie from 'js-cookie';
import { browser } from '@/lib/ua';

// 获取内核
const os = {
  isInWx() {
    return navigator.userAgent.toLowerCase().match(/MicroMessenger/i) !== null;
  },
  isWeiBo() {
    return navigator.userAgent.toLowerCase().match(/Weibo/i) !== null;
  },
  isInAPP() {
    return Cookie.get('MT_USER_INFO') !== undefined;
  },
  isInH5() {
    return !this.isInAPP() && !this.isInWx();
  },
};

const util = {
  secondFormat(second, type) {
    const seconds = util.fillNumber(second % 60);
    const minutes = util.fillNumber(parseInt(second / 60, 10));
    let result = '';
    switch (type) {
      case 'MM:SS':
        result = `${minutes}:${seconds}`;
        break;
    }
    return result;
  },
  dateFormat(numbers, type) {
    if (!numbers) {
      numbers = (new Date()).getTime();
    }
    const date = new Date(Number(numbers));
    const year = date.getFullYear();
    const month = util.fillNumber(date.getMonth() + 1);
    const day = util.fillNumber(date.getDate());
    const hours = util.fillNumber(date.getHours());
    const minutes = util.fillNumber(date.getMinutes());
    const seconds = util.fillNumber(date.getSeconds());
    let result = '';
    switch (type) {
      case 'YYYY年MM月DD日':
        result = `${year}年${month}月${day}日`;
        break;
      case 'MM月DD日 HH:MM':
        result = `${month}月${day} ${hours}:${minutes}`;
        break;
      case 'HH:MM':
        result = `${hours}:${minutes}`;
        break;
      case 'YYYY/MM/DD':
        result = `${year}/${month}/${day}`;
        break;
      default:
        result = `${month}月${day} ${hours}:${minutes}`;
        break;
    }
    return result;
  },
  // 格式化为两位数字，如果为 1 则格式化为01
  fillNumber(number) {
    if (number < 0) {
      number = 0;
    }
    return number > 9 ? number : `0${number}`;
  },
  base64Decode(str) {
    var c1, c2, c3, c4;
    var base64DecodeChars = new Array(
      -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
      -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
      -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57,
      58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0,  1,  2,  3,  4,  5,  6,
      7,  8,  9,  10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
      25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
      37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1,
      -1, -1
    );
    var i=0, len = str.length, string = '';

    while (i < len){
      do{
        c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
      } while (
      i < len && c1 == -1
        );

      if (c1 == -1) break;

      do{
        c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
      } while (
      i < len && c2 == -1
        );

      if (c2 == -1) break;

      string += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

      do{
        c3 = str.charCodeAt(i++) & 0xff;
        if (c3 == 61)
          return string;

        c3 = base64DecodeChars[c3]
      } while (
      i < len && c3 == -1
        );

      if (c3 == -1) break;

      string += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));

      do{
        c4 = str.charCodeAt(i++) & 0xff;
        if (c4 == 61) return string;
        c4 = base64DecodeChars[c4]
      } while (
      i < len && c4 == -1
        );

      if (c4 == -1) break;

      string += String.fromCharCode(((c3 & 0x03) << 6) | c4)
    }
    return string;
  },
  fomartDuration(second) {
    if (second > 60) {
      let s = second % 60;
      let m = parseInt(second / 60, 10);

      if (m > 60) {
        let h = parseInt(m / 60, 10);
        m = parseInt(second / 60, 10) % 60;
        if (h < 10) {
          h = `0${m}`;
        }
        if (m < 10) {
          m = `0${m}`;
        }
        if (s < 10) {
          s = `0${s}`;
        }
        return `${h} : ${m} : ${s}`;
      }
      if (m < 10) {
        m = `0${m}`;
      }
      if (s < 10) {
        s = `0${s}`;
      }
      return `${m}:${s}`;
    }
    return `${second}s`;
  },
  // 获取美囤版本号
  getMTVersion () {
    const mtui = Cookie.get('MT_USER_INFO') || '';
    const fck = mtui.split(',');
    if (fck.length > 2) {
      return this.base64Decode(fck[1])
    }
    return '';
  },
  // 获取客户端信息
  getClientInfo () {
    const clientInfo = decodeURIComponent(Cookie.get('MT_CLIENT_INFO'))
    if (!clientInfo || clientInfo === 'null' || clientInfo === 'undefined') {
      return {}
    }
    return JSON.parse(clientInfo) || {}
  },
  // 版本比较
  latestVersion (currentVer, version) {
    const curVer = currentVer.split('.')
    const specVer = version.split('.')

    for(let i = 0, len = curVer.length; i < len; i ++){
      if(curVer[i] !== specVer[i]){
        return curVer[i] - specVer[i] > 0 ? true : false
      }
      if(i >= len - 1){
        return false
      }
    }

    return false
  },
  // 检测是否支持 sticky
  supportSticky() {
    const testEle = document.createElement('div');
    let props = '-webkit-sticky';
    testEle.style.position = props;
    if (testEle.style.position) {
      return testEle.style.position === props;
    }
    props = 'sticky';
    testEle.style.position = props;
    return testEle.style.position === props;
  },
  // 获取 open_way
  getOpenWay() {
    if (!browser) {
      return 3;
    }
    if (browser.wx) {
      return 0;
    } else if (browser.qq) {
      return 1;
    } else if (browser.app) {
      return 2;
    }
    return 3;
  }
};

export { os, util };



// WEBPACK FOOTER //
// ./src/lib/utils.js